module.exports = __webpack_public_path__ + "img/capa2.0150093b.webp";